import PricingTable from 'components/PricingTable';
import { useAnimation } from 'hooks/useAnimation';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectPricingCompare } from 'store/slices/PricingSlice';

const PricingTabs = ({ isLoading }) => {
    const container = useRef();
    // const isLoading = useSelector(selectPricingIsLoading);

    useAnimation({
        items: ['.pricing-table h2', '.table-container'],
        container,
        dependencies: [isLoading],
    })
    const products = useSelector(selectPricingCompare)
    return (
        <section ref={container} className='inner-container pricing-table'>
            <h2>{products.title}</h2>
            <PricingTable />
        </section>
    );
}

export default PricingTabs;